import * as t from "io-ts";

import { Months, ProductAPIURL } from "./nominals";
import { NullBoolean, NullString, nullable } from "./utils";

const PostDiscountAddon = t.readonly(
    t.type({
        name: t.string,
        price_excl_tax: t.string,
    }),
);

const PostDiscountAddons = t.readonlyArray(PostDiscountAddon);

export type IPostDiscountAddons = t.TypeOf<typeof PostDiscountAddons>;

export const Price = t.readonly(
    t.intersection([
        t.type({
            currency: NullString,
            excl_tax: NullString,
            incl_tax: NullString,
            tax: NullString,
        }),
        t.partial({
            retail: NullString,
            cosmetic_excl_tax: NullString,
            cosmetic_incl_tax: NullString,
            enable_per_month_pricing: NullBoolean,
            per_month: NullString,
            per_month_term_length: nullable(Months),
            post_discount_addons: PostDiscountAddons,
        }),
    ]),
);

export type IPrice = t.TypeOf<typeof Price>;

export const APIPrice = t.readonly(
    t.type({
        product: ProductAPIURL,
        quantity: t.number,
        unit: Price,
        total: Price,
    }),
);

export type IAPIPrice = t.TypeOf<typeof APIPrice>;

export type IPriceQuantity = [number, IPrice];
